import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import { getBodyShowCostsQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCosts/getBodyShowCostsQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بیمه گذار / کارشناسی" header="titleHeader">
      <BodyShowCosts />
    </MainLayout>
  );
};

const BodyShowCosts = () => {
  const { id } = useParams();
  const { data } = useQuery(getBodyShowCostsQueryOptions({ id: +id! }));

  return (
    <Box pt={24}>
      <ShowIncidentParticipantsDataCard
        data={data?.showCosts || []}
        title="هزینه‌ها"
      >
        <CostTotalPrice totalPrice={data?.totalPrice || 0} />
      </ShowIncidentParticipantsDataCard>
    </Box>
  );
};

const CostTotalPrice = (data: { totalPrice: number }) => {
  return (
    <Box
      w="100%"
      bg={data?.totalPrice < 0 ? 'pink-2' : 'green-4'}
      px={8}
      py={5}
      borderRadius={4}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mt={16}
      mb={30}
    >
      <Typography
        textStyle="b4"
        color={data?.totalPrice < 0 ? 'red' : 'green-1'}
      >
        مجموع هزینه :
      </Typography>
      <Typography
        textStyle="b4"
        color={data?.totalPrice < 0 ? 'red' : 'green-1'}
      >
        {`${data?.totalPrice?.toLocaleString('fa')} ریال`}
      </Typography>
    </Box>
  );
};
